var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M3.704.37L3.334 0 1.852 1.482.37 0 0 .37l1.482 1.482L0 3.334l.37.37 1.482-1.482 1.482 1.482.37-.37-1.482-1.482z"}})}
var staticRenderFns = []

export { render, staticRenderFns }